
export default function ProfilePage({ authUser }) {

    return (
        <div>Profile main</div>
    )
}